import { FC, useEffect, useRef, useState } from "react";
import { shortcutType } from "./reactGridHelper";
import { CellWrapper, useCellContext } from "@silevis/reactgrid";
import styles from './CustomCheckboxCell.module.scss';

interface CheckboxCellProps {
  value: boolean;
  onValueChanged: (newValue: boolean) => void;
  format: string;
  onAddRow?: (rowIndex: number) => void;
  onDeleteRow?: (rowIndex: number) => void;
  allowShortcuts?: shortcutType[];
}

export const CustomCheckboxCell: FC<CheckboxCellProps> = ({
  value,
  onValueChanged,
  onAddRow,
  onDeleteRow,
  allowShortcuts = [],
}) => {

  const ctx = useCellContext();
  const [isEditMode, setEditMode] = useState(false);
  const [currentValue, setCurrentValue] = useState<boolean>(value ? true : false);
  const escapePressedRef = useRef(false);

  useEffect(() => {
    setCurrentValue(value ? true : false);
  }, [value]);

  useEffect(() => {
    if (!ctx.isFocused) return; // Ensure shortcut only works when cell is focused

    const handleKeyDown = (e: KeyboardEvent) => {
      if ((e.ctrlKey || e.metaKey) && e.shiftKey && (e.key === "+" || e.key === "=")) {
        e.preventDefault();
        if (allowShortcuts.includes(shortcutType.addRow)) {
          console.log('ctx.realRowIndex', ctx.realRowIndex)
          onAddRow?.(ctx.realRowIndex - 1);
        }
      } else if ((e.ctrlKey || e.metaKey) && e.key === "-") {
        e.preventDefault();
        if (allowShortcuts.includes(shortcutType.deleteRow)) {
          onDeleteRow?.(ctx.realRowIndex - 1);
        }
      }
    };

    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, [ctx.isFocused, onAddRow, onDeleteRow, allowShortcuts]);

  return (
    <CellWrapper
      onStringValueRequested={() => value as any}
      onStringValueReceived={(v) => {
        // console.log('string value received', v);
        return onValueChanged?.(v as any);
      }}
      onDoubleClick={() => {
        ctx.isFocused && setEditMode(true);
      }}
      onKeyDown={(e) => {
        if (!isEditMode && e.key === "Enter") {
          e.stopPropagation();
          setEditMode(true);
        }
        if (e.code == "Space") {
          e.stopPropagation();
          const newValue = !currentValue;
          setCurrentValue(newValue);
          onValueChanged(newValue);
        }
      }}
    >
      <input
        className={styles.checkboxInput}
        onCut={(e) => e.stopPropagation()}
        onCopy={(e) => e.stopPropagation()}
        onPaste={(e) => e.stopPropagation()}
        onPointerDown={(e) => e.stopPropagation()}
        onChange={(e) => {
          const newValue = e.target.checked;
          setCurrentValue(newValue);
          onValueChanged(newValue);
        }} type='checkbox' checked={currentValue}
        onKeyDown={(e) => {
          const controlKeys = ["Escape", "Enter", "Tab"];
          if (!controlKeys.includes(e.key)) {
            e.stopPropagation();
          }
          if (e.key === "Escape") {
            escapePressedRef.current = true;
            setEditMode(false);
          } else if (e.key === "Enter") {
            // console.log('enter key pressed')
            // setCurrentValue(e.currentTarget.value)
            onValueChanged?.(e.currentTarget.checked);
            setEditMode(false);
          } else if (e.key === "Tab") {
            // setCurrentValue(e.currentTarget.value)
            onValueChanged?.(e.currentTarget.checked);
            setEditMode(false);
          }
        }}
        autoFocus
      />
    </CellWrapper>
  )
}